module.exports = __webpack_public_path__ + "img/dept-7.4f4e43f3.svg";